import React from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  CardBody,
  Button,
  Collapse,
  Form,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { updateTranslations } from '../../../actions/translations';

class EditForms extends React.PureComponent {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      collapse: null,
      itemTitle: null,
      itemIndex: null,
    };
  }

  handleTranslationUpdate = (tab, title, section, formSection, event) => {
    const newValue = event.target.value;
    updateTranslations(tab, title, section, formSection, newValue);
  };

  toggle(index) {
    this.setState((prevState) => {
      const collapseState = prevState.collapse === index ? null : index;
      return ({ collapse: collapseState });
    });
  }

  renderFormSections = (tab, title, section, translations) => (
    Object.keys(translations[tab][title][section]).map((formSection) => {
      const { edit } = this.props;
      return (
        <div>
          <FormGroup>
            <Label for={formSection}><i>{formSection}</i></Label>
            <Input
              disabled={!edit}
              type="textarea"
              style={{
                height: translations[tab][title][section][formSection].length > 200
                  ? '60px'
                  : 'calc(1.5em + .75rem + 2px)',
              }}
              id={formSection}
              value={translations[tab][title][section][formSection]}
              onChange={(e) => this.handleTranslationUpdate(tab, title, section, formSection, e)}
            />
          </FormGroup>
        </div>
      );
    })
  );

  renderForm = (title, tab, translations) => {
    const sections = (translations[tab][title]);
    const display = [];
    if (sections) {
      Object.keys(sections).forEach((section) => {
        display.push(
          <div className="mb-2">
            <b>{section}</b>
          </div>,
          <hr />,
          <Form>
            {this.renderFormSections(tab, title, section, translations)}
          </Form>,
          <hr />,
        );
      });
    }

    return display;
  };

  render() {
    const { titles, tab, translations } = this.props;
    const { collapse, itemTitle, itemIndex } = this.state;
    return (
      <Row>
        <Col>
          <div>
            {titles.map((title, index) => (
              <Button
                onClick={() => {
                  this.toggle(index);
                  this.setState({
                    itemTitle: (itemTitle === title) ? null : title,
                    itemIndex: (itemIndex === index) ? null : index,
                  });
                }}
                data-event={index}
                key={title}
                className="ms-1 mt-1"
                color={itemTitle === title ? 'primary' : 'secondary'}
                style={{ borderRadius: '10px' }}
              >
                <b>{title}</b>
              </Button>
            ))}
            <Collapse isOpen={collapse === itemIndex}>
              <CardBody>
                {this.renderForm(itemTitle, tab, translations)}
              </CardBody>
            </Collapse>
          </div>
        </Col>
      </Row>
    );
  }
}

export default connect()(EditForms);
